"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.many = exports.plus = exports.optional = exports.matchFalse = exports.matchTrue = exports.matchTokenType = exports.match = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _chain = require("./chain");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function equalWordOrIncludeWords(str, word) {
  if (typeof word === 'string') {
    return judgeMatch(str, word);
  }

  return word.some(function (eachWord) {
    return judgeMatch(str, eachWord);
  });
}

function judgeMatch(source, target) {
  if (source === null) {
    return false;
  }

  return (source && source.toLowerCase()) === (target && target.toLowerCase());
}

function matchToken(scanner, compare, isCostToken) {
  var token = scanner.read();

  if (!token) {
    return {
      token: null,
      match: false
    };
  }

  if (compare(token)) {
    if (isCostToken) {
      scanner.next();
    }

    return {
      token: token,
      match: true
    };
  }

  return {
    token: token,
    match: false
  };
}

function createMatch(fn, specialName) {
  return function (arg) {
    function foo() {
      return function (scanner, isCostToken) {
        return fn(scanner, arg, isCostToken);
      };
    }

    foo.parserName = 'match';
    foo.displayName = specialName;
    return foo;
  };
}

var match = createMatch(function (scanner, word, isCostToken) {
  return matchToken(scanner, function (token) {
    return equalWordOrIncludeWords(token.value, word);
  }, isCostToken);
});
exports.match = match;

var matchTokenType = function matchTokenType(tokenType) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var options = _objectSpread({
    includes: [],
    excludes: []
  }, opts);

  return createMatch(function (scanner, word, isCostToken) {
    return matchToken(scanner, function (token) {
      if (options.includes.some(function (includeValue) {
        return judgeMatch(includeValue, token.value);
      })) {
        return true;
      }

      if (options.excludes.some(function (includeValue) {
        return judgeMatch(includeValue, token.value);
      })) {
        return false;
      }

      if (token.type !== tokenType) {
        return false;
      }

      return true;
    }, isCostToken);
  }, tokenType)();
};

exports.matchTokenType = matchTokenType;

var matchTrue = function matchTrue() {
  return {
    token: null,
    match: true
  };
};

exports.matchTrue = matchTrue;

var matchFalse = function matchFalse() {
  return {
    token: null,
    match: true
  };
};

exports.matchFalse = matchFalse;

var optional = function optional() {
  for (var _len = arguments.length, elements = new Array(_len), _key = 0; _key < _len; _key++) {
    elements[_key] = arguments[_key];
  }

  if (elements.length === 0) {
    throw Error('Must have arguments!');
  }

  return (0, _chain.chain)([_chain.chain.apply(void 0, elements)(function (ast) {
    return elements.length === 1 ? ast[0] : ast;
  }), true])(function (ast) {
    return ast[0];
  });
};

exports.optional = optional;

var plus = function plus() {
  for (var _len2 = arguments.length, elements = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    elements[_key2] = arguments[_key2];
  }

  if (elements.length === 0) {
    throw Error('Must have arguments!');
  }

  var plusFunction = function plusFunction() {
    return (0, _chain.chain)(_chain.chain.apply(void 0, elements)(function (ast) {
      return elements.length === 1 ? ast[0] : ast;
    }), optional(plusFunction))(function (ast) {
      if (ast[1]) {
        return [ast[0]].concat(ast[1]);
      }

      return [ast[0]];
    });
  };

  return plusFunction;
};

exports.plus = plus;

var many = function many() {
  if (arguments.length === 0) {
    throw Error('Must have arguments!');
  }

  return optional(plus.apply(void 0, arguments));
};

exports.many = many;